import _DevelopmentPriceNoteService from "../services/development-price-note-service";
import { IDevelopmentPriceNoteService } from "../types/services/development-price-note-service";

const instance = new _DevelopmentPriceNoteService();

const DevelopmentPriceNoteService: IDevelopmentPriceNoteService = instance;

export default DevelopmentPriceNoteService;
